const scrollSnoop = function scrollSnoop(element, state) {
  const bounding = element.getBoundingClientRect();
  const type = state || '';

  let result = bounding.top <= window.innerHeight && bounding.bottom >= 0 && getComputedStyle(element).display !== 'none';
  if (type === 'strict') {
    result = bounding.top <= window.innerHeight && bounding.bottom >= 0 && bounding.left <= window.innerWidth && bounding.right >= 0 && getComputedStyle(element).display !== 'none';
  }
  return result;
};

exports.default = scrollSnoop;